// Kartu Rumus: pop-up berisi rumus yang terkait soal, atau semua rumus satu mapel.
import { S } from './state.js';
import { modalLebar } from './modal.js';
import { ELEMEN } from '../content/validasi.js';

const kartuHTML = c => `<article class="rumus-card"><h4>${c.judul}</h4><div class="rumus-f">${c.rumus}</div>${c.keterangan ? `<p>${c.keterangan}</p>` : ''}${c.contoh ? `<p class="rumus-ex"><b>Contoh:</b> ${c.contoh}</p>` : ''}</article>`;

export const kartuUntuk = (ids, mapel = S.mapel) => {
  const semua = S.konten?.rumus?.[mapel] || [];
  return (ids || []).map(id => semua.find(c => c.id === id)).filter(Boolean);
};

export function bukaRumus(ids) {
  const kartu = kartuUntuk(ids);
  if (!kartu.length) return;
  modalLebar(`<div class="modal-head"><b>Kartu Rumus</b><span class="grow"></span><button class="btn btn-sm btn-pink" data-close type="button">Tutup</button></div><div class="scroll rumus-grid">${kartu.map(kartuHTML).join('')}</div>`, { label: 'Kartu rumus', cls: 'modal-rumus' });
}

// Semua kartu rumus satu mapel: tab per elemen, pencarian, dan daftar yang bisa digulir.
export function bukaSemuaRumus(mapel = S.mapel) {
  const semua = S.konten?.rumus?.[mapel] || [];
  const grup = [...ELEMEN, 'Lainnya'].map(el => ({ el, kartu: semua.filter(c => el === 'Lainnya' ? !ELEMEN.includes(c.elemen) : c.elemen === el) })).filter(g => g.kartu.length);
  let tab = 'semua', cari = '';
  const m = modalLebar(`<div class="modal-head"><b>Kartu Rumus</b><span class="muted" style="font-weight:700">${semua.length} rumus</span><span class="grow"></span><button class="btn btn-sm btn-pink" data-close type="button">Tutup</button></div>
    <div class="rumus-tools"><div class="tabs" role="tablist"><button class="tab" role="tab" data-el="semua" type="button">Semua (${semua.length})</button>${grup.map(g => `<button class="tab" role="tab" data-el="${g.el}" type="button">${g.el} (${g.kartu.length})</button>`).join('')}</div>
      <input class="input rumus-cari" type="search" placeholder="Cari rumus, misalnya luas atau KPK" aria-label="Cari rumus"></div>
    <div class="scroll rumus-body" role="tabpanel"></div>`, { label: 'Semua kartu rumus', cls: 'modal-semua-rumus' });
  const body = m.querySelector('.rumus-body'), tabs = [...m.querySelectorAll('[data-el]')];
  const teks = c => (c.judul + ' ' + c.rumus + ' ' + c.keterangan).replace(/<[^>]+>/g, ' ').toLowerCase();
  const render = () => {
    tabs.forEach(b => b.setAttribute('aria-selected', b.dataset.el === tab));
    const q = cari.trim().toLowerCase();
    const tampil = grup.filter(g => tab === 'semua' || g.el === tab).map(g => ({ ...g, kartu: g.kartu.filter(c => !q || teks(c).includes(q)) })).filter(g => g.kartu.length);
    body.innerHTML = tampil.length
      ? tampil.map(g => `<section><h3 class="rumus-el">${g.el}</h3><div class="rumus-grid">${g.kartu.map(kartuHTML).join('')}</div></section>`).join('')
      : `<p class="muted rumus-kosong">${semua.length ? 'Rumus yang dicari tidak ditemukan.' : 'Belum ada kartu rumus.'}</p>`;
    body.scrollTop = 0;
  };
  tabs.forEach(b => b.onclick = () => { tab = b.dataset.el; render(); });
  m.querySelector('.rumus-cari').addEventListener('input', e => { cari = e.target.value; render(); });
  render();
}
